import useSWR from 'swr';
import { useContext, useEffect } from 'react';
import { AppContext } from 'providers/AppProvider';
import { LoadingAction } from 'store/actions';
import { LoadingState } from 'store/state';
import { processIdSelector } from 'store/selectors';
import { Products } from 'types';
import { ProductsURL } from 'helpers';

export function useCreditCheck() {
	const ctx = useContext(AppContext);
	const processId = processIdSelector(ctx.state.context);
	const { config, dispatch, goToNextPage, t } = ctx;
	const { API } = config;
	const { data, isLoading } = useSWR<Products>(ProductsURL(API, processId, false));
	const message = t('loading_text', 'products');

	useEffect(() => {
		data && data.hasInternalCreditCheck && goToNextPage();
	}, [data]); // eslint-disable-line

	useEffect(() => {
		const msg = isLoading ? message : '';
		dispatch([LoadingAction, { loading: LoadingState(0, msg) }]);
	}, [isLoading]); // eslint-disable-line

	return { ...ctx, data };
}
